import { useMemo, createElement } from 'react';
import 'react/jsx-runtime';
import '../../../_utils/components/InputError.module.scss.js';
import 'clsx';
import 'tslib';
import 'primereact/tooltip';
import '../../../_utils/components/InputLabel.module.scss.js';
import { renderOverflowTooltipLabel } from '../../../_utils/components/OverflowTooltipLabel.js';
import { getLabelText } from '../../../_utils/plain-label.utils.js';
import { getSelectedNodes } from '../utils/tree-select-checkbox-selection.utils.js';

function useTreeSelectValuePresentation(_ref) {
  let {
    display,
    inputValueTemplate,
    nodeMaps,
    placeholder,
    selectionFlags,
    selectionMode,
    value
  } = _ref;
  const selectedNodes = useMemo(() => selectionFlags.useExternalSelectedValueLayout || selectionFlags.shouldUseOverflowValueTemplate ? getSelectedNodes(value, selectionMode, nodeMaps) : [], [nodeMaps, selectionFlags.shouldUseOverflowValueTemplate, selectionFlags.useExternalSelectedValueLayout, selectionMode, value]);
  const valueTemplate = useMemo(() => resolveValueTemplate({
    inputValueTemplate,
    placeholder,
    selectedNodes,
    selectionFlags,
    selectionMode
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [inputValueTemplate, placeholder, selectedNodes, selectionMode, selectionFlags.shouldUseOverflowValueTemplate, selectionFlags.useExternalSelectedValueLayout]);
  return {
    display: selectionFlags.useExternalSelectedValueLayout ? 'comma' : display,
    selectedNodes,
    shouldRenderSelectedPills: selectionFlags.useExternalSelectedValueLayout && selectedNodes.length > 0,
    valueTemplate
  };
}
function resolveValueTemplate(_ref2) {
  let {
    inputValueTemplate,
    placeholder,
    selectedNodes,
    selectionFlags,
    selectionMode
  } = _ref2;
  if (selectionFlags.useExternalSelectedValueLayout) {
    return function externalValueTemplate() {
      return placeholder !== null && placeholder !== void 0 ? placeholder : null;
    };
  }
  if (!selectionFlags.shouldUseOverflowValueTemplate) {
    return inputValueTemplate;
  }
  return function overflowValueTemplate() {
    var _a;
    if (selectedNodes.length === 0) {
      return placeholder ? /*#__PURE__*/createElement('span', null, placeholder) : null;
    }
    const label = selectionMode === 'single' ? getLabelText((_a = selectedNodes[0]) === null || _a === void 0 ? void 0 : _a.label) : selectedNodes.map(node => getLabelText(node.label)).filter(currentLabel => currentLabel !== null).join(', ');
    return renderOverflowTooltipLabel(label, 'ics-overflow-label');
  };
}

export { useTreeSelectValuePresentation };
